
import '../../../assets/css/listgrid.css';
import './style.css';
import bagIcon from '../../../assets/img/chart-area.svg';
import boxOpenIcon from '../../../assets/img/users.svg';
import fireIcon from '../../../assets/img/dolly-flatbed.svg';
import pdfIcon from '../../../assets/img/draw-circle.svg';

const ListGrid = () => {
    return (
      <>
        <div id="ba9fda79-7591-49aa-b0ad-2545f645244e" className="containerv2" style={{padding: '50px 0'}}>
            <div className="containerv2__regions" data-container-regions style={{'maxWidth': '1320px'}}>
                <div className="containerv2__region containerv2__region--12" data-region>
                <div id="3bde1f73-2638-4fc2-af34-e4e14b0b5353" className="text-content">
                    <div className="text-content__content" data-wysiwyg>
                            <h1>Intuitive Brand Partner Portal</h1>
                        </div>
                    </div>

                    <div id="SH44336132-5cd1-43ab-8946-a8f4c449438b"
                        className="listgrid shouse-homelist listgrid--icon-list listgrid--justify listgrid--justify-even "
                        data-carousel-items="1">
                        <ul className="listgrid__list" >
                            <li className="listgrid__item" style={{'justifyContent': 'center'}}>
                                <div className="listgrid__header">
                                    <div className="listgrid__icon text-center">
                                        <img src={bagIcon} className="icon" alt="cog icon"/>
                                    </div>
                                  
                                </div>
                                <div className="text-content__content" data-wysiwyg>
                                    <h5 className="text-center">Real Time<br />Analytics</h5>
                                </div>
                            </li>
                            <li className="listgrid__item" style={{'justifyContent': 'center'}}>
                                <div className="listgrid__header">
                                    <div className="listgrid__icon text-center">
                                        <img src={boxOpenIcon} className="icon" alt="cog icon"/>
                                    </div>
                                  
                                </div>
                                <div className="text-content__content" data-wysiwyg>
                                    <h5 className="text-center">Customers<br />& Sales</h5>
                                </div>
                            </li>
                            <li className="listgrid__item" style={{'justifyContent': 'center'}}>
                                <div className="listgrid__header">
                                    <div className="listgrid__icon text-center">
                                        <img src={fireIcon} className="icon" alt="cog icon"/>
                                    </div>
                                  
                                </div>
                                <div className="text-content__content" data-wysiwyg>
                                    <h5 className="text-center">Products<br />& Inventory</h5>
                                </div>
                            </li>
                            <li className="listgrid__item" style={{'justifyContent': 'center'}}>
                                <div className="listgrid__header">
                                    <div className="listgrid__icon text-center">
                                        <img src={pdfIcon} className="icon" alt="cog icon"/>
                                    </div>
                                  
                                </div>
                                <div className="text-content__content" data-wysiwyg>
                                    <h5 className="text-center">Trends<br />&nbsp;</h5>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>  
            </div>
        </div>
      </>
    )
}
 
export default ListGrid
